/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Currency of card account. Must be a valid ISO 4217 currency code.
Please consult your solution manager to ensure the correct account currency for your offered card products

 */
export type CreateCardAccountBodyCurrency = typeof CreateCardAccountBodyCurrency[keyof typeof CreateCardAccountBodyCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCardAccountBodyCurrency = {
  HKD: 'HKD',
  USD: 'USD',
} as const;
